<template>
  <div class="body container">
    <div class="nav clearfix">
      <a
        :class="{ active: column.id == columnid }"
        href="#"
        v-for="column in brotherColumnData"
        :key="column.id"
        @click="
          changeColumn(
            column.mode,
            column.id,
            column.web_level,
            column.fix_column_name
          )
        "
        >{{ column.title }}</a
      >
    </div>
    <div class="content wrapper clearfix">
      <div class="newsBox fl">
        <div class="sortBox clearfix">
          <div class="sort fl">
            <a
              :class="{ active: orderby == 0 }"
              href="#"
              @click="articleSort(0)"
              >时间排序</a
            >
            <a
              :class="{ active: orderby == 1 }"
              href="#"
              @click="articleSort(1)"
              >点击量排序</a
            >
          </div>
          <div class="searchBox fr">
            <span class="des">共{{ recordcount }}条结果</span>
            <div>
              <el-input
                v-model="keyword"
                placeholder="关键字搜索，标题"
                class="handle-input mr10 keyword"
                @keyup.enter.native="getArticleData"
              ></el-input>
              <a
                class="searchBtn"
                href="javascript:"
                @click="getArticleData"
              ></a>
            </div>
          </div>
        </div>
        <ul class="news" style="padding:0px">
          <li
            class="newsList clearfix"
            v-for="article in articleData"
            :key="article.id"
            @click="toArticleInfo(article.schoolid, article)"
            style="cursor: pointer"
          >
            <div class="date fl">
              <h1>{{ article.month_day }}</h1>
              <p>{{ article.year }}</p>
            </div>
            <div class="detail" style="width:100%">
              <a style="cursor: pointer">{{ article.title }}</a>
              <p class="intro" v-html="article.summary"></p>
            </div>
          </li>
        </ul>
        <div class="noData" v-if="nodata">
          <img src="../../assets/img/no_article.png" />
          <p>暂无文章类型资源，去别的地方看看吧~</p>
        </div>
      </div>
    </div>
    <div class="btnGroup" style="background: #f6f9fa">
      <div class="pagination">
        <el-pagination
          background
          hide-on-single-page
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :total="this.recordcount"
          :current-page="this.page"
          :page-size="this.pagesize"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="jumpVisable"
      width="30%"
      style="color: red"
    >
      <span>即将跳转：{{ link }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jumpVisable = false">取 消</el-button>
        <el-button type="primary" @click="goActicleInfo()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
export default {
  name: "ArticleList",
  data() {
    return {
      nodata: false,
      columnid: "",
      weblevel: "",
      mode: "",
      orderby: "0",
      brotherColumnData: [],
      articleData: [],
      hotData: [],
      keyword: "",
      page: 1,
      pagesize: 10,
      recordcount: 0,
      school_id: 0,
      jumpVisable: false,
      link: "",
    };
  },

  components: {},

  computed: {
    globalVaranthasInited() {
      return globalApi.gWebsiteSessionInfo.hasInited;
    },
  },
  watch: {
    $route() {
      //监控$route
      this.page = 1;
      this.keyword = "";
      this.columnid = this.$route.query.id;
      this.school_id = this.$route.query.schoolid;
      this.weblevel = this.$route.query.web_level;
      this.mode = this.$route.query.mode;
      this.getArticleData();
      this.getBrotherColumns();
      // this.getColumnTitle();
    },
    globalVaranthasInited: function () {
      this.init();
    },
  },

  created() {
    this.columnid = this.$route.query.id;
    this.weblevel = this.$route.query.web_level;
    this.school_id = this.$route.query.schoolid;
    this.mode = this.$route.query.mode;
  },

  methods: {
    goActicleInfo() {
      window.open(this.link);
      this.jumpVisable = false;
    },
    init() {
      this.columnid = this.$route.query.id;
      this.weblevel = this.$route.query.web_level;
      this.school_id = this.$route.query.schoolid;
      this.mode = this.$route.query.mode;
      this.getArticleData();
      this.getBrotherColumns();
    },
    toArticleInfo(schoolid, article) {
      if (article.mode == 5) {
        this.getArticleInfo(article.id);
      } else {
        globalApi.jumpPath(
          2,
          "articleInfo",
          "schoolid=" +
            schoolid +
            "&articleid=" +
            article.id +
            "&columnid=" +
            this.columnid
        );
      }
    },
    async getArticleInfo(id) {
      let data = {
        s: "WebSchoolSpace.ColumnContent.getArticleInfo",
        articleid: id,
      };
      const response = await globalApi.post(data);
      const res = response.data.data;
      if (res.result == 1) {
        this.link = res.info.content;
        this.jumpVisable = true;
      } else {
        this.$message.error("没有查询到文章信息！");
      }
    },
    changeColumn(mode, id, web_level, address) {
      if (mode == 1) {
        address = "Article";
      } else if (mode == 2) {
        address = "ArticleList";
      } else if (mode == 3) {
        address = "VideoList";
      }
      this.$router.push(
        String(
          address +
            "?mode=" +
            mode +
            "&id=" +
            id +
            "&web_level=" +
            web_level +
            "&schoolid=" +
            this.$route.query.schoolid
        )
      );
    },
    //文章排序
    articleSort(index) {
      this.page = 1;
      this.orderby = index;
      this.getArticleData();
    },
    // 分页导航
    handleCurrentChange(val) {
      this.page = val;
      document.documentElement.scrollTop = 0;
      this.getArticleData();
    },

    async getBrotherColumns() {
      let data = {
        s: "WebSchoolSpace.Column.GetBrotherColumn",
        columnid: this.columnid,
        weblevel: this.weblevel,
      };

      let res = await globalApi.post(data);
      this.brotherColumnData = res.data.data;
    },
    async getArticleData() {
      let data = {
        s: "WebSchoolSpace.ColumnContent.SearchArticle",
        columnid: this.columnid,
        weblevel: this.weblevel,
        page: this.page,
        pagesize: this.pagesize,
        keyword: this.keyword,
        orderby: this.orderby,
      };
      let res = await globalApi.post(data);

      if (res.data.ret == 200 && res.data.data.result == 1) {
        this.recordcount = res.data.data.recordcount;
        this.type = res.data.data.type;
        let articleData = res.data.data.list;
        for (let i = 0; i < articleData.length; i++) {
          articleData[i].year = articleData[i].create_time.slice(0, 4);
          articleData[i].month_day = articleData[i].create_time.slice(5, 10);
        }
        this.articleData = articleData;

        this.nodata = this.recordcount ? false : true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/index_body.scss";
.keyword {
  width: 90%;
}
.news .newsList .detail {
  a {
    line-height: 30px;
  }
  .intro {
    width: 1200px;
  }
}
.nav {
  margin-bottom: 15px;
}
</style>


